// Horizontally scrollable L2/L3 filter chips within the active department
// (#63 AC3/AC4). The active chip is filled; a clear button resets to the full
// L1 view.
import React from 'react';
import type { Category } from '../shared/types';
import { subcategoriesOf } from '../services/category-nav';

const CategoryFilterBar: React.FC<{
  categories: Category[];
  l1Id: string;
  activeCategoryId: string;          // 'All' or a category id
  onSelect: (id: string) => void;    // select an L2/L3 chip
  onClear: () => void;               // back to the full L1 view / departments
}> = ({ categories, l1Id, activeCategoryId, onSelect, onClear }) => {
  const subs = subcategoriesOf(categories, l1Id);

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1">
      <button
        onClick={onClear}
        className="shrink-0 min-h-[36px] px-3 py-1.5 rounded-lg font-black text-xs bg-rose-500/10 text-rose-500 hover:bg-rose-500/20 flex items-center gap-1"
      >
        ✕ Zurücksetzen
      </button>
      {subs.map((c) => {
        const active = activeCategoryId === c.id;
        return (
          <button
            key={c.id}
            onClick={() => onSelect(c.id)}
            className={`shrink-0 min-h-[36px] px-4 py-1.5 rounded-lg font-bold text-xs transition-all ${
              active ? 'bg-emerald-500 text-dark' : 'bg-slate-50 dark:bg-dark-border/30 text-slate-500 hover:bg-emerald-500/10'
            } ${c.level === 3 ? 'opacity-90' : ''}`}
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilterBar;
